export enum AuthKey {
  Manager = 'manager',
  Online = 'online',
}

export interface Auth<User extends AuthUser = AuthUser> {
  isAuthenticated: () => boolean;
  setUser: (user: User | null) => void;
  getUser: () => User | null;
  refreshLogin: () => void;
}

export type ManagerAuthUser = {
  id: string;
};

export type OnlineAuthUser = {
  id: string;
  isAdminLogin?: boolean;
  needNewPassword: boolean;
  needMigrationHint: boolean;
  participantId?: string | null;
  cycleId?: string;
  conceptId?: string;
  totalNumberOfParticipants?: number;
};

export type AuthUser = ManagerAuthUser | OnlineAuthUser;
